let About = {
    toggleGreetingDirector: function(btn){
        let containerText = btn.closest('[data-text-greeting-director]'),
            descrWrap = containerText.find('[data-wrap-descr-greeting-director]'),
            descr = descrWrap.find('[data-descr-greeting-director]');

        if(descrWrap.hasClass('open')) {
            descrWrap.stop().animate({ height: 270 }, 400, function() {
                descrWrap.removeClass('open').removeAttr('style');
            });
        }else {
            descrWrap.stop().animate({ height: descr.height() }, 400, function() {
                descrWrap.addClass('open').removeAttr('style');
            });
        }
    },
    openInfoDirector: function(e){
        e.preventDefault();

        $('body').addClass('open-info-director');
        setTimeout(function(){
            $('body').addClass('bg-info-director');
        }, 100);
    },
    closeInfoDirector: function(e){
        $('body').removeClass('bg-info-director');
        setTimeout(function(){
            $('body').removeClass('open-info-director');
        }, 300);
    }
}

$(document).ready(function($) {

    let btnMoreDescrGreetingDirector = $('[data-more-descr-greeting-director]');
    if(btnMoreDescrGreetingDirector.length) {

        btnMoreDescrGreetingDirector.on('click', function(){
            About.toggleGreetingDirector(btnMoreDescrGreetingDirector);
        });
    }

    let btnOpenInfoDirectorAbout = $('[data-btn-open-info-director-about]');
    if (btnOpenInfoDirectorAbout.length) {

        btnOpenInfoDirectorAbout.on('click', function(e){
            About.openInfoDirector(e);
        });
    };

    let btnCloseInfoDirectorAbout = $('[data-btn-close-info-director-about]');
    if (btnCloseInfoDirectorAbout.length) {

        btnCloseInfoDirectorAbout.on('click', function(e){
            About.closeInfoDirector(e);
        });
    };

    $(document).on('click', function(e){
        let _target = $(e.target);

        if( _target.closest('.info-director').length || 
            _target.closest('[data-btn-open-info-director-about]').length) {
            return;
        }
        e.stopPropagation();

        About.closeInfoDirector(e);
    });
});


// WEBPACK FOOTER //
// ./components/about.js